<template>

    <div id="konfigurator-suroviny">

        <h1>{{ 'Make your own Haffit' | translate }}</h1>

        <div class="error-msg" v-if="errorMessage">{{ errorMessage }}</div>

        <div v-show="!isStepValid() && this.tryEscape" class="info-messages-box">
            <div v-if="!isStepValid() && this.tryEscape" class="error-msg">
                {{ 'At least one ingredient that does not contain an allergen must be selected from each category.' | translate }}
            </div>
            <div v-if="!existValidOption">
                {{ 'We are not able to offer you a feed for you pet' | translate }}
            </div>
        </div>

        <div v-if="typSlozkyItems" class="form-content">
        <div class="summary-subtitle">
            {{ 'Only with us can you directly affect the composition of the food. Choose your meat and side dish.' | translate }}
        </div>
			<!-- <div class="rovnice">
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
			</div> -->

            <div v-if="akcniKombinace.length > 0" class="suroviny-akce">
                <div v-if="akcniKombinace" class="suroviny-skupina">

                    <h2>{{ 'Sale combinations' | translate }}</h2>

                    <div class="form-radios">
                        <div v-for="item in akcniKombinace"
                             :class="{'form-type-radio' : true}"
                             :key="item.id">
                            <input type="radio"
                                   v-model="zvolenaAkcniKombinace"
                                   :value="item"
                                   :id="'kombinace-' + item.id"
                                   @change="akcniKombinaceChange">
                            <label :for="'kombinace-' + item.id">
                                <div class="ico"></div>
                                <div class="item-title">{{ item.nazev_cj }}</div>
                                <div v-if="item.popis_cj.length > 0" class="item-desc"
                                     v-html="item.popis_cj"></div>
                                <div class="sale">{{ 'Sale' | translate }}</div>
                            </label>
                        </div>
                    </div>

                </div>
            </div>

            <div class="suroviny">
                <div v-if="typSlozkyItems[0]" class="suroviny-skupina">

                    <h2>{{ typSlozkyItems[0].title }}</h2>

                    <div class="form-radios" v-bind:class="{ 'has-error':!isMasovaValid() && this.tryEscape }">
                        <div v-for="item in typSlozkyItems[0].items"
                             :class="{'form-type-radio' : true, 'form-type-radio-disabled': item.alergic || item.status == 0, 'pripravujeme': item.status == 0 }"
                             :key="item.id">
                            <input type="radio" :name="typSlozkyItems[0].id_typ_slozky"
                                   v-model="mazlicek.suroviny.slozky[typSlozkyItems[0].id_typ_slozky]"
                                   :value="item.id" :id="item.id" :disabled="item.alergic || item.status == 0"
                                   @change="slozkaChange">
                            <label :for="item.id">
                                <div class="item-title">{{ item.title }}</div>
                                <div v-if="item.description.length > 0" class="item-desc"
                                     v-html="item.description"></div>
                                <div v-if="item.alergic" class="suroviny-alergic-info">
                                    <div class="suroviny-alergic-info-icn"></div>
                                    <div class="suroviny-alergic-info-desc">{{ 'Includes allergen' | translate }}</div>
                                </div>
                                <div v-if="item.status == 0" class="suroviny-pripravujeme-info">
                                    <div class="suroviny-pripravujeme-info-icn"></div>
                                    <div class="suroviny-pripravujeme-info-desc">{{ 'Coming soon' | translate }}</div>
                                </div>
                                <img v-if="item.filename" :src="getSlozkaImageUrl(item.filename)"/>
                            </label>
                        </div>
                    </div>

                </div>
                <div v-if="typSlozkyItems[1]" class="suroviny-skupina">

                    <h2>{{ typSlozkyItems[1].title }}</h2>

                    <div class="form-radios"
                         v-bind:class="{ 'has-error':!isPrilohaValid() && this.tryEscape }">
                        <div v-for="item2 in typSlozkyItems[1].items"
                             :class="{'form-type-radio' : true, 'form-type-radio-disabled': item2.alergic || item2.status == 0, 'pripravujeme': item2.status == 0 }"
                             :key="item2.id">
                            <input type="radio" :name="typSlozkyItems[1].id_typ_slozky"
                                   v-model="mazlicek.suroviny.slozky[typSlozkyItems[1].id_typ_slozky]"
                                   :value="item2.id" :id="item2.id" :disabled="item2.alergic || item2.status == 0"
                                   @change="slozkaChange">
                            <label :for="item2.id">
                                <div class="item-title">{{ item2.title }}</div>
                                <div v-if="item2.description.length > 0" class="item-desc"
                                     v-html="item2.description"></div>
                                <div v-if="item2.alergic" class="suroviny-alergic-info"><div class="suroviny-alergic-info-icn"></div><div class="suroviny-alergic-info-desc">{{ 'Includes allergen' | translate }}</div></div>
                                <div v-if="item2.status == 0" class="suroviny-pripravujeme-info"><div class="suroviny-pripravujeme-info-icn"></div><div class="suroviny-pripravujeme-info-desc">
                                  {{ 'Coming soon' | translate }}</div></div>
                                <img v-if="item2.filename" :src="getSlozkaImageUrl(item2.filename)"/>
                            </label>
                        </div>
                    </div>

                </div>
                <!--<div class="suroviny-skupina">-->

                    <!--<h2>{{ typSlozkyItems[2].title }}</h2>-->

                    <!--<div class="form-radios" v-bind:class="{ 'has-error':!isMineralniValid() && this.tryEscape }">-->
                        <!--<div v-for="item3 in typSlozkyItems[2].items"-->
                             <!--:class="{'form-type-radio' : true, 'form-type-radio-disabled': item3.alergic}"-->
                             <!--:key="item3.id">-->
                            <!--<input type="radio" :name="typSlozkyItems[2].id_typ_slozky"-->
                                   <!--v-model="mazlicek.suroviny.slozky[typSlozkyItems[2].id_typ_slozky]"-->
                                   <!--v-bind:value="item3.id" :id="item3.id" :disabled="item3.alergic">-->
                            <!--<label :for="item3.id">-->
                                <!--<div class="item-title">{{ item3.title }}</div>-->
                                <!--<div v-if="item3.description.length > 0" class="item-desc"-->
                                     <!--v-html="item3.description"></div>-->
                            <!--</label>-->
                        <!--</div>-->
                    <!--</div>-->

                <!--</div>-->
            </div>

        </div>

        <info :krok="9"></info>

        <navigace
                :showPrev="true"
                :onClickPrev="prev"
                :showNext="true"
                :disableNext="!valid"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>

    </div>

</template>

<script>
import {validationMixin} from 'vuelidate'
import {apiSilex} from '../api'
import navigace from './Navigace'
import info from './Info'

export default {
        components: {navigace, info},
        mixins: [validationMixin],
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                typSlozkyItems: [],
                slozkaItemsPetIsAlergicTo: null,
                // slozkaItems: [],
                // test: {},
                tryEscape: false,
                errorMessage: '',
                akcniKombinace: [],
                zvolenaAkcniKombinace: null

            }
        },
        computed: {
            valid: function () {
                return (this.mazlicek.suroviny.valid = !this.$v.mazlicek.suroviny.$invalid)
            },
            existValidOption() {
                let exist = true

                this.typSlozkyItems.forEach((itemType) => {
                    let noAlergicItem = itemType.items.find((item) => item.alergic == false)
//                    console.log(itemType.items)
                    exist = exist && (noAlergicItem !== undefined)
                })
                return exist
            }
        },
        methods: {
            slozkaChange(event) {
                this.setAkcniKombinace()
            },
            setAkcniKombinace() {
                let masovaId = this.mazlicek.suroviny.slozky[1]
                let prilohovaId = this.mazlicek.suroviny.slozky[2]
                if(masovaId && prilohovaId) {
                    this.zvolenaAkcniKombinace = this.akcniKombinace
                        .filter(item =>
                            item.slozka_masova_id === masovaId
                            && item.slozka_prilohova_id === prilohovaId
                        ).pop()
                }
            },
            akcniKombinaceChange(event) {
                this.mazlicek.suroviny.slozky[1] = this.zvolenaAkcniKombinace.slozka_masova_id
                this.mazlicek.suroviny.slozky[2] = this.zvolenaAkcniKombinace.slozka_prilohova_id
            },
          getSlozkaImageUrl(filename) {
            if (filename) {
              return '/sites/default/files/aplikace/slozka/' + filename
            } else {
              return '';
            }
          },
            /*
            onSurovinaChange: function (id, typ) {
              this.mazlicek.suroviny.suroviny.forEach(function (entry) {
                if (entry.id_typ_slozky === typ) {
                  var index = entry.items.indexOf(id)
                  if (index === -1) {
                    entry.items.push(id)
                  } else {
                    entry.items.splice(index, 1)
                  }
                }
              })
            },
            */
//            getTypSlozkyItems: function (typ) {
//                var a = []
//                this.slozkaItems.forEach(function (entry) {
//                    if (entry.id_typ_slozky === typ) {
//                        entry.is_alergic = (this.mazlicek.alergie.alergeny.indexOf(entry.id) != -1) ? true : false
//                        a.push(entry)
//                    }
//                })
//                return a
//            },
            prev: function () {
                this.$router.push({name: 'alergie'})
            },
            isMasovaValid: function () {
                let keys = Object.keys(this.mazlicek.suroviny.slozky)
                return keys.includes('1')
            },
            isPrilohaValid: function () {
                let keys = Object.keys(this.mazlicek.suroviny.slozky)
                return keys.includes('2')
            },
            isMineralniValid: function () {
                let keys = Object.keys(this.mazlicek.suroviny.slozky)
                return keys.includes('3')
            },
            isSelectedValuesValid: function () {
              if(this.slozkaItemsPetIsAlergicTo){
                let meatItemsContainingAlergens = this.slozkaItemsPetIsAlergicTo.filter(item => item.id === this.mazlicek.suroviny.slozky[1])
                let sideDishItemsContainingAlergens = this.slozkaItemsPetIsAlergicTo.filter(item => item.id === this.mazlicek.suroviny.slozky[2])
                return meatItemsContainingAlergens.length === 0 && sideDishItemsContainingAlergens.length === 0
              }
            },
            isStepValid: function () {
//                return this.isMasovaValid() && this.isPrilohaValid() && this.isMineralniValid()
                return this.isMasovaValid() && this.isPrilohaValid() && this.isSelectedValuesValid()
            },
            isPetAlergicOnNutrition(nutrition) {
                let isAlergic = this.slozkaItemsPetIsAlergicTo.find(item => item.id === nutrition.id)

                return isAlergic !== undefined
            },

            async loadNutritionGroupByTypes() {

              let slozky = await apiSilex.get('/slozka')
              .then(response => response.data)
              .catch(error => console.log(error))

              apiSilex.get('/typ_slozky')
              .then(response => {
                this.typSlozkyItems = response.data
                this.typSlozkyItems.forEach(typSlozky => {
                  typSlozky.items = []

                  typSlozky.items = slozky.filter(item => {
                    item.alergic = this.isPetAlergicOnNutrition(item)

                    return item.id_typ_slozky == typSlozky.id_typ_slozky
                  })

                  this.$forceUpdate()
                })
              })
              .catch(error => console.log(error))
            },
            saveAndQuit: function () {
              if (this.isStepValid()) {
                this.mazlicek.suroviny.slozky[3] = 0

                this.$store.dispatch('updateProduct', this.mazlicek)
                  .then(response => {
                    if (response.data.status.code != 200) return this.errorMessage = response.data.status.message

                    const feedData = response.data.data.product.feedData
                    this.mazlicek.suroviny.valid = true
                    this.mazlicek.krmivo.feedData = feedData
                    this.mazlicek.krmivo.cena.den = feedData.feedRatio.totalPrice
                    this.$store.commit('setMazlicek', this.mazlicek)
                    window.location.href = 'prihlaseni'
                  })
                  .catch(error => {
                    console.error(error)
                  })
              } else {
                this.tryEscape = true
                this.animateAfterError()
              }
            },
            next: function () {
                if (this.isStepValid()) {
                    this.mazlicek.suroviny.slozky[3] = 0
                    // let updatePetP = this.$store.dispatch('updatePet', this.mazlicek)
                    // let updateProductP = this.$store.dispatch('updateProduct', this.mazlicek)

                    this.$store.dispatch('updateProduct', this.mazlicek)
                        .then(response => {
                            // dočasná podmínky pro případ: 'Pro zadanou kombinaci složek nebylo nalezeno žádné míchání v tabulce: app_michani_slozek'
                            if (response.data.status.code != 200) return this.errorMessage = response.data.status.message

                            const feedData = response.data.data.product.feedData
                            this.mazlicek.suroviny.valid = true
                            this.mazlicek.krmivo.feedData = feedData
                            this.mazlicek.krmivo.cena.den = feedData.feedRatio.totalPrice
                            this.$store.commit('setMazlicek', this.mazlicek)
                            this.$router.push({name: 'hotovekrmivo'})
                        })
                        .catch(error => {
                            console.error(error)
                            this.$router.push({name: 'hotovekrmivo'})
                        })
                } else {
                    this.tryEscape = true
                    this.animateAfterError()
                }
            },
            animateAfterError(){
                jQuery('html, body').animate({
                        scrollTop: jQuery('.app-content-left').offset().top - jQuery('#primary').height()
                    },
                    '500'
                )
            },
            mountinMethod(){
                this.mazlicek.step.current = 9
                this.$cookies.set('lastVisitedStep', 9)
                jQuery('html, body').animate({scrollTop: 0}, '500')
                let url = '/slozka?is-alergic=true&alergen=' + this.mazlicek.alergie.alergeny.toString()
                apiSilex.get(url).then(response => {
                    this.slozkaItemsPetIsAlergicTo = response.data
                    this.loadNutritionGroupByTypes()
                })

                url = '/akcni-kombinace'
                if(this.mazlicek.alergie.alergie) {
                    url += '?alergeny=' + this.mazlicek.alergie.alergeny.join()
                }
                apiSilex.get(url).then(response => {
                    this.akcniKombinace = response.data
                })

                this.setAkcniKombinace()
            }
        },
        mounted: function () {
            this.mountinMethod()
        },
        validations: {
            mazlicek: {
                suroviny: {
                    valid: function () {
                        let keys = Object.keys(this.mazlicek.suroviny.slozky)

                        return (keys.length === this.typSlozkyItems.length)
                    }
                }
            }
        },
        watch: {
            'mazlicek.productLoaded': {
                deep: true,
                handler: function (val) {
                    if (val.value)
                        this.mountinMethod()
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// 09Suroviny.vue?0c8ec101